import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { AppLogo } from '@/components/AppLogo';
import { Button } from '@/components/ui/button';

export function ReportPageHeader() {
  const navigate = useNavigate();
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className='flex items-center justify-between flex-wrap gap-4 px-6 pt-6 pb-5'
    >
      <Button
        variant='ghost'
        onClick={() => navigate('/clients')}
        className='hover:opacity-80 p-0 h-auto'
      >
        <AppLogo />
      </Button>
      <Button variant='outline' onClick={() => navigate('/reports')} className='gap-2'>
        <ArrowLeft className='w-4 h-4' /> Назад
      </Button>
    </motion.div>
  );
}
